import React from "react";
import { mainTable } from "../css/Common";

const PopUpButtons = ({
  deleteDetails,
  submitDetails,
  uploadDetails,
  blockDetails,
  unBlockDetails,
  disabledBtn,
  rowIndex,
  handleSubmit,
  handleUpload,
  cancel,
  buttonLabel = "",
}) => {
  return (
    <div className={mainTable.submitCancelMainDiv}>
      {deleteDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 3)}
          disabled={disabledBtn}
        >
          Delete
        </button>
      )}
      {submitDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 3)}
          disabled={disabledBtn}
        >
          {buttonLabel === "" ? "Submit" : buttonLabel}
        </button>
      )}

      {blockDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 4)}
          disabled={disabledBtn}
        >
          Make Inactive
        </button>
      )}
      {unBlockDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleSubmit(rowIndex, 5)}
          disabled={disabledBtn}
        >
          Make Active
        </button>
      )}
      {uploadDetails && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={
            disabledBtn
              ? mainTable.disabledSubmitButton
              : mainTable.submitButton
          }
          onClick={() => handleUpload(rowIndex, 6)}
          disabled={disabledBtn}
        >
          Submit
        </button>
      )}
      <button
        data-modal-hide="bottom-right-modal"
        type="button"
        className={mainTable.cancelButton}
        onClick={() => cancel()}
      >
        CANCEL
      </button>
    </div>
  );
};

export default PopUpButtons;
